/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_S4_P1Inputs */

const en_guide_json_syntax_errors_s4_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In JavaScript objects, keys without special characters don't need quotes. In JSON, every key must be a double-quoted string: no exceptions.`)
};

const ko_guide_json_syntax_errors_s4_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JavaScript 객체에서는 특수 문자가 없는 키에 따옴표가 필요하지 않습니다. JSON에서는 모든 키가 반드시 큰따옴표로 감싼 문자열이어야 합니다: 예외 없이.`)
};

const ja_guide_json_syntax_errors_s4_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JavaScriptオブジェクトでは、特殊文字を含まないキーにはクォートが不要です。JSONでは、すべてのキーがダブルクォートで囲まれた文字列でなければなりません: 例外はありません。`)
};

/**
* | output |
* | --- |
* | "In JavaScript objects, keys without special characters don't need quotes. In JSON, every key must be a double-quoted string: no exceptions." |
*
* @param {Guide_Json_Syntax_Errors_S4_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_s4_p1 = /** @type {((inputs?: Guide_Json_Syntax_Errors_S4_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_S4_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_s4_p1(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_s4_p1(inputs)
	return ja_guide_json_syntax_errors_s4_p1(inputs)
});